import React from "react";
import { useI18n } from "../../i18n";

/** Small blocking confirm used for destructive or unusual register actions. */
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  tone = "primary",
  onConfirm,
  onCancel,
}) => {
  const { t } = useI18n();

  if (!open) return null;

  const confirmClasses =
    tone === "danger"
      ? "bg-red-600 hover:bg-red-500"
      : "bg-primary-600 hover:bg-primary-500";

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-5">
      <button
        type="button"
        aria-label={cancelLabel || t("common.cancel")}
        onClick={onCancel}
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
      />
      <div className="relative w-full max-w-sm bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl p-5">
        <h3 className="text-lg font-bold text-white">{title}</h3>
        <p className="text-sm text-slate-300 mt-2">{message}</p>
        <div className="grid grid-cols-2 gap-3 mt-5">
          <button
            type="button"
            onClick={onCancel}
            className="h-12 rounded-xl bg-slate-800 text-slate-200 font-semibold hover:bg-slate-700 transition-colors"
          >
            {cancelLabel || t("common.cancel")}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`h-12 rounded-xl text-white font-semibold transition-colors ${confirmClasses}`}
          >
            {confirmLabel || t("common.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
